export default __webpack_public_path__ + "static/media/avatar_111.7672deb2.png";